parseTokenDDD